<!-- 查看导入学员 -->
<template>
    <div class="basicStyle">
        <h1 style="margin-bottom:20px">
            【 <span>{{$route.query.name}}</span> 】开通学员详情，开通订单数共
            <span style="color:red">{{allInfo.count}}</span>个
            （总计费用<span style="color:red">{{allInfo.total_fee}}</span>）
            已扣款订单<span style="color:red">{{allInfo.activation_count}}</span>个
            （总计费用<span style="color:red">{{allInfo.activation_total_fee}}</span>）
        </h1>
      <div class="querySearch">
        <div class="searchItem">
          <span>用户信息</span>
          <el-input class="w300" v-model="queryInfo.keyword" clearable size="small" placeholder=请输入学员登录账号/真实姓名/手机号></el-input>
        </div>
        <div class="searchItem">
          <span>订单号</span>
          <el-input class="w300" v-model="queryInfo.order_id" clearable size="small" placeholder=请输入订单号></el-input>
        </div>
        <div class="searchItem">
          <span>订单状态</span>
          <el-select v-model="queryInfo.pay_status" size="small" class="w100Select">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="已取消" :value="2"></el-option>
              <el-option label="已开通" :value="0"></el-option>
              <el-option label="已扣款" :value="1"></el-option>
              <el-option label="已退款" :value="3"></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>学员标签</span>
          <!-- <el-input class="w180" v-model="queryInfo.goods" clearable size="small"></el-input> -->
          <el-select
                v-model="queryInfo.user_tag"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod1"
                :loading="loading"
                :clearable="true"
                size="mini"
              >
                <el-option
                  v-for="(item, index) in options1"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>开通时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            range-separator="至"
            @change="selectData"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="searchItem">
            <!-- <el-button type="primary" size="small" @click="queryTable">搜索</el-button>
            <el-button type="warning" size="small" @click="resetQuery">重置</el-button>  -->
            <MyButton
              value="搜索"
              size="medium"
              icon="el-icon-search"
              type="1"
              @click="queryTable"
            ></MyButton>
            <MyButton
              value="重置"
              size="medium"
              type="2"
              @click="resetQuery"
            ></MyButton>

        </div>
      </div>
      <div class="table">
        <TableComponents :columns="columns" :tableData="tableList" :tableFunction="tableFunction" @choiceGoods="choiceGoods">
          <!-- 学员标签管理 -->
          <template slot="studentLabel" slot-scope="{row}">
            <el-popover
              placement="right"
              trigger="hover"
              v-if="row.tags.length>3"
              >
              <div style="width:200px">
                <el-tag v-for="(item,index) in row.tags" :key="index" style="margin:5px">{{item}}</el-tag>
              </div>
              <div slot="reference">
                <el-tag v-for="(item,index) in row.tags" :key="index" style="margin:5px" v-show="index<3">{{item}}</el-tag>
                ...
              </div>
            </el-popover>
            <div v-else>
              <el-tag v-for="(item,index) in row.tags" :key="index" style="margin:5px">{{item}}</el-tag>
            </div>
          </template>
          <template slot="operation" slot-scope="{row}">
            <span class="operationItem" @click="viewDetail(row,1)">查看学员信息</span>
            </template>
        </TableComponents>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total">
        </el-pagination>
      </div>
  
      <!-- 新增编辑弹窗 -->
      <el-dialog :title="dialogType" :visible.sync="addFormShow" class="formDialog" width="500px">
        <el-form :model="userInfo" :rules="rules" ref="userInfoForm" label-width="100px">
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="userInfo.mobile" placeholder="请输入手机号" size="mini" disabled></el-input>
          </el-form-item>
          <el-form-item label="真实姓名：" prop="realname">
            <el-input v-model="userInfo.realname" placeholder="请输入真实姓名(2-6个汉字）" size="mini" disabled></el-input>
          </el-form-item>
          <el-form-item label="身份证：" prop="id_card">
            <el-input v-model="userInfo.id_card" placeholder="请输入身份证" size="mini" disabled></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="userInfo.remark" placeholder="请输入备注" size="mini" disabled></el-input>
          </el-form-item>
          <el-form-item label="状态：">
            <el-radio-group v-model="userInfo.status" size="mini" disabled>
              <el-radio-button :label="1">启用</el-radio-button>
              <el-radio-button :label="0">禁用</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </el-dialog>

    </div>
  </template>
  
  <script>
  import studentApi from '@/api/student.js'
  import goodsApi from '@/api/goods.js'
  import TableComponents from '@/components/TableComponents.vue'
  import MyButton from "@/components/MyButton.vue";
  export default {
    name:'ImportStudent',
    components:{
      TableComponents,
      MyButton
    },
    data(){
      var confirmPasswordVerify = (_, value, callback) => {
        if (!value) {
          return callback(new Error("确认密码不能为空"));
        } else if (value != this.codeInfo.new_password_confirmation) {
          return callback(new Error("两次密码输入需一致"));
        } else {
          callback();
        }
      };
      return{
        allInfo:{
            count:"",
            total_fee:"",
            activation_count:"",
            activation_total_fee:""
        },
        options:[],
        options1:[],
        loading:false,
        queryInfo:{
          limit:10,
          page:1,
          total:0,
          keyword:"",
          order_id:"",
          start_time:"",
          end_time:"",
          user_tag:"",
          pay_status:-1,
          // pay_at:[]
        },
        columns:[//列数据
          {label:"学员ID",prop:"uid"},
          {label:'学员登录账号',prop:'user_no'},
          {label:'真实姓名',prop:'realname'},
          {label:'学员标签',prop:'tags',width:200},
          {label:'手机号',prop:'mobile'},
          {label:'订单号',prop:'order_no'},
          {label:'备注',prop:'remark'},
          // {label:'状态',prop:'userextStatus'},
          // {label:'今日学习时长',prop:'learn_time'},
          // {label:'累计学习时长',prop:'leann_total_time'},
        //   {label:'已开通商品',prop:'courses',width:200},
          {label:'订单状态',prop:'payStudentStatus'},
          {label:'学员激活状态',prop:'active_status_txt'},
          {label:'实际扣款时间',prop:'pay_at'},
          {label:'开通时间（订单创建的时间）',prop:'created_at'},
          {label:'过期时间',prop:'expire_at'},
          {label:'操作',prop:'operation'},
        ],
        tableList:[],
        // 新增编辑表单数据
        addFormShow:false,
        userInfo:{
          mobile:"",
          realname:'',
          id_card:"",
          remark:"",
          status:1,
          uid:''
        },
        rules:{
          mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' },],                
          realname: [{ required: true, message: '请输入真实姓名', trigger: 'blur' },],           
        },
        tableFunction:{
            checkData:0,//是否允许勾选
            name:"choiceGoods"
        },

        // 选中的学员
        selectStudent:[],
        timeFrame:[]
      }
    },
    computed:{
      dialogType(){
        //  'this.userInfo.id',this.userInfo.uid);
        return '查看学员'
      }
    },  
    watch:{
      selectBuyGoodsShow:{
        handler(_newVal){
          //  _newVal);
        }
      },  
      addFormShow:{
        handler(_newVal){
          if(!_newVal){
            Object.keys(this.userInfo).forEach(key =>{
              if(typeof this.userInfo[key] == 'string'){
                this.userInfo[key] = ''
              }else if((typeof this.userInfo[key] == 'number')){
                this.userInfo[key] = 1
              }
            });
            this.userInfo.uid = ''
          }
        }
      },
      timeFrame:{
        handler(_newVal){
          if(!_newVal){
            this.timeFrame = [];
          }
        },
        deep:true
      },
    },
    created(){
      this.queryTable()
    },  
    methods:{
      remoteMethod(query) {
        if (query !== "") {
          this.loading = true;
          setTimeout(async () => {
            this.loading = false;
            const companyName = query;
            const res = await studentApi.tobGoodList({ good_name: companyName });
            this.options = res.data;
          }, 200);
        } else {
          this.options = [];
        }
      },
      remoteMethod1(query) {
        if (query !== "") {
          this.loading = true;
          setTimeout(async () => {
            this.loading = false;
            const companyName = query;
            const res = await studentApi.tobTagsList({ name: companyName });
            this.options1 = res.data.data;
          }, 200);
        } else {
          this.options = [];
        }
      },
      // 列表数据
      async queryTable(_type){
        if(_type){
          this.queryInfo.page = 1
        }
        this.queryInfo.tob_good_id = this.$route.query.id
        const res = await goodsApi.tobGPowerUser(this.queryInfo)
        if(res.code == 200){
          this.queryInfo.total = res.data.list.total
          this.tableList = res.data.list.data
          this.allInfo = res.data.all_info
          this.tableList.forEach((item,index) => { 
            if(item.quser&&item.quser.uid){
              item.uid = item.quser.uid
            }
            if(item.quser&&item.quser.username){
              item.username = item.quser.username
            }
            if(item.quser&&item.quser.realname){
              item.realname = item.quser.realname
            }
            if(item.userext&&item.userext.mobile){
              item.mobile = item.userext.mobile
            }
            if(item.userext&&item.userext.is_active){
              item.is_active = item.userext.is_active
            }
            if(item.userext&&item.userext.id_card){
              item.id_card = item.userext.id_card
            }
            if(item.userext&&item.userext.remark){
              item.remark = item.userext.remark
            }
            // item.uid = item.quser.uid
            // item.username = item.quser.username
            // item.realname = item.quser.realname
            // item.mobile = item.userext.mobile
            // item.is_active = item.userext.is_active
            // item.status = item.userext.status
            // item.id_card = item.userext.id_card
            // item.remark = item.userext.remark
            let _payStatus = ''
            if(item.is_study_card==1){ 
              _payStatus = item.study_card_pay_status_name
            }else{
              switch (item.pay_status) {
                  case 0:
                  _payStatus = '已开通'
                  break
                  case 1:
                  _payStatus = '已扣款'
                  break
                  case 2:
                  _payStatus = '已取消'
                  break
                  case 3:
                  _payStatus = '已退款'
                  break
                  case 4:
                  _payStatus = '已扣款' //退款中
                  break
                  case 5:
                  _payStatus = '已扣款' //退款失败
                  break
                  case 6:
                  _payStatus = '未支付'  
                  break
                  case 7:
                  _payStatus = '已扣款'  
                  break
              }
            }
            item.payStudentStatus = _payStatus
            // if(item.userext&&item.userext.status==1){
            //   // status 状态1启用，0
            //   item.userextStatus = '启用'  
            // }else{
            //   item.userextStatus = '禁用' 
            // }

            
          });
            
          //  this.tableList);
        }else{
          this.$message.error(res.message)
        }
      },
      // 打开弹窗
      viewDetail(row){
        if(row.uid){
          // Object.assign(this.userInfo,row)
          this.$router.push({
            path:"/studentManage",
            query:{name:row.quser.realname}
          })
        }
        //  this.userInfo);
        // this.addFormShow = true
      },
      // 添加｜｜修改数据
      addUser(formName){
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            let res
            if(this.userInfo.uid){
              res = await studentApi.studentsEdit(this.userInfo)
            }else{
              res = await studentApi.studentsAdd(this.userInfo)
            }
            if(res.code == 200){
              this.$message.success(`${this.dialogType}成功`)
              this.queryTable()
              this.addFormShow = false
            }else{
              this.$message.error(res.message)
            }
          } else {
            //  'error submit!!');
            return false;
          }
        });
      },
  
  
      // 分页
      handleSizeChange(e){
        //  e);
        this.queryInfo.limit = e
        this.queryTable()
      },
      handleCurrentChange(e){
        this.queryInfo.page = e
        this.queryTable()
      },
      resetQuery(){
        this.timeFrame = []
        this.queryInfo = {
          limit:10,
          page:1,
          total:0,
          keyword:"",
          order_id:"",
          start_time:"",
          end_time:"",
          user_tag:"",
          pay_status:-1,
          // pay_at:[]
        }
        this.queryTable()
      },
      // 选择日期
      selectData(e){
        //  e);
        if(e){
          this.queryInfo.start_time = e[0]
          this.queryInfo.end_time = e[1]
        }else{
          this.queryInfo.start_time = ''
          this.queryInfo.end_time = ''
        }
      },

      choiceGoods(e){
        //  e);
        this.selectStudent = e
      },
      async addCourse(){
        let _obj = this.selectStudent.map(item=>{
            return item.uid
        })
        const res =await goodsApi.addCoursePower({
            tob_user_id:_obj.join(","),
            course_id:this.$route.query.courseId
        })
        if(res.code == 200){
            this.$message.success("添加学员成功")
        }else{
          this.$message.error(res.message)
        }
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .basicStyle{
    span{
      display: inline-block;
    }
    .querySearch{
      .searchItem{
        display: inline-block;
        margin: 0 20px 20px 0 ;
        span{
          margin-right: 10px;
          font-size: 14px;
        }
        /deep/ .el-input{
          width: 230px;
        }
      }
      /deep/ .el-button--primary{
        margin-left: 50px;
      }
    }
    .addInfo{
      margin: 20px 0;
    }
  
    // 表格数据
    .table{
      min-height: calc(100vh - 330px);
      .studentLabel{
        display: inline-block;
        padding: 5px 10px;
        background-color: #409EFF;
        color: #fff;
        border-radius: 4px;
        margin: 0 5px 5px 0;
      }
    }
    .operationItem{
      display: inline-block;
      margin: 0 5px;
      cursor: pointer;
      color: rgb(87, 87, 239);
    }
  
    /deep/ .formDialog{
      .el-select .el-input{
        width: 180px;
      }
      .el-input{
        width: 250px;
      }
      .dialog-footer{
        text-align: center;
      }
    }
  }
  
  // 添加标签样式
  /deep/ .editLabelClass{
    display: flex;
    align-items: flex-start;
    .p1{
      margin-right: 20px;
      width: 70px;
      line-height: 30px;
    }
    .p2{
      flex: 1;
    }
    .el-tag{
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .searchItem{
      .el-input{
        width: 200px;
        margin: 0 20px;
      }
    }
  }
  .editLabelClass+.editLabelClass{
    margin-top: 20px;
  }

  /deep/ .el-input.is-disabled .el-input__inner{
    background-color: #fff;
    color: #606266;
  }
  /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    background-color: #409EFF;
    color: #fff;
  }
  </style>